/**
 * GBA/ITC Gateway API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CompaniesControllerRequestCredentialDelivery200Response { 
    success?: boolean;
    message?: string;
    deliveryMethod?: CompaniesControllerRequestCredentialDelivery200Response.DeliveryMethodEnum;
    credentialsDelivered?: number;
}
export namespace CompaniesControllerRequestCredentialDelivery200Response {
    export const DeliveryMethodEnum = {
        DidComm: 'DIDComm',
        CredentialService: 'CredentialService',
        Email: 'Email'
    } as const;
    export type DeliveryMethodEnum = typeof DeliveryMethodEnum[keyof typeof DeliveryMethodEnum];
}


